export const affiliatedClubs = [
  {
    id: 'royal-sydney',
    name: 'The Royal Club, Sydney',
    location: 'Sydney, Australia',
    image:
      'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: 'A prestigious harbor-side club offering exceptional dining and accommodation.',
    longDesc:
      "Located on the stunning Sydney Harbour, The Royal Club offers our members full reciprocal privileges. Facilities include three dining venues, a state-of-the-art fitness center, and 15 luxury guest suites. Members visiting Sydney can enjoy the club's prime location and impeccable service.",
    keyDetails: [
      {
        label: 'Reciprocal Rights',
        value: 'Full Access (Dining, Sports, Accommodation)',
      },
      { label: 'Location', value: 'Sydney Harbour, NSW' },
      { label: 'Booking', value: 'Letter of Introduction Required' },
    ],
  },
  {
    id: 'new-york-athletic',
    name: 'Manhattan Athletic Club',
    location: 'New York, USA',
    image:
      'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    desc: 'Premier sporting and social club in the heart of Manhattan.',
    longDesc:
      'The Manhattan Athletic Club is renowned for its world-class sporting facilities and vibrant social scene. Overlooking Central Park, the club features an Olympic-sized swimming pool, indoor track, multiple dining rooms, and extensive guest accommodations. It serves as an excellent base for members traveling to New York for business or leisure.',
    keyDetails: [
      {
        label: 'Reciprocal Rights',
        value: 'Full Access (Max 14 days per year)',
      },
      { label: 'Location', value: 'Central Park South, NY' },
      { label: 'Booking', value: 'Letter of Introduction Required' },
    ],
  },
  {
    id: 'tokyo-heritage',
    name: 'Tokyo Cultural Club',
    location: 'Tokyo, Japan',
    image:
      'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1194&q=80',
    desc: 'An oasis of calm and tradition in bustling Tokyo.',
    longDesc:
      'The Tokyo Cultural Club blends traditional Japanese hospitality with classic private club amenities. Situated in a quiet district of Tokyo, it offers exquisite dining options ranging from authentic Kaiseki to French cuisine. The club also features beautiful private gardens, a library, and meeting facilities.',
    keyDetails: [
      { label: 'Reciprocal Rights', value: 'Dining and Meeting Facilities' },
      { label: 'Location', value: 'Minato City, Tokyo' },
      { label: 'Booking', value: 'Letter of Introduction Required' },
    ],
  },
]

export const getAffiliatedClubBySlug = (slug: string) =>
  affiliatedClubs.find((c) => c.id === slug)
